import { render, staticRenderFns } from "./insured-add.vue?vue&type=template&id=68473500&"
import script from "./insured-add.vue?vue&type=script&lang=js&"
export * from "./insured-add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports